import * as THREE from 'three';

/** Text-only assessment hold; the encounter audio remains on its master clock. */
export class AssessmentPlaceholder {
  readonly group = new THREE.Group();
  private readonly panelMaterial: THREE.MeshBasicMaterial;
  private readonly placeholderTexture: THREE.CanvasTexture;
  private replacementTexture?: THREE.VideoTexture;

  constructor() {
    this.group.name = 'physical-assessment-interlude';
    this.group.position.set(0, 0.12, -4.7);
    this.group.visible = false;
    this.placeholderTexture = new THREE.CanvasTexture(drawAssessmentPanel());
    this.placeholderTexture.colorSpace = THREE.SRGBColorSpace;
    this.panelMaterial = new THREE.MeshBasicMaterial({ map: this.placeholderTexture, transparent: true, opacity: .98, depthTest: false, toneMapped: false });
    const geometry = new THREE.PlaneGeometry(5.9, 3.25, 28, 1);
    const positions = geometry.attributes.position;
    for (let i=0; i<positions.count; i++) positions.setZ(i, -.2*Math.pow(positions.getX(i)/3,2));
    positions.needsUpdate = true;
    geometry.computeVertexNormals();
    const panel = new THREE.Mesh(geometry, this.panelMaterial);
    panel.renderOrder = 10;
    this.group.add(panel);
  }
  setVisible(visible: boolean): void { this.group.visible = visible; }
  setReducedMotion(_reduced: boolean): void { /* Static, text-only card. */ }
  update(_elapsed: number, _audioEnergy: number): void { /* No animated symbols. */ }
  setMedia(video: HTMLVideoElement | null): void {
    this.replacementTexture?.dispose();
    this.replacementTexture = undefined;
    if (video) {
      this.replacementTexture = new THREE.VideoTexture(video);
      this.replacementTexture.colorSpace = THREE.SRGBColorSpace;
      this.replacementTexture.minFilter = THREE.LinearFilter;
      this.replacementTexture.magFilter = THREE.LinearFilter;
      this.replacementTexture.generateMipmaps = false;
    }
    this.panelMaterial.map = this.replacementTexture ?? this.placeholderTexture;
    this.panelMaterial.needsUpdate = true;
  }
  dispose(): void {
    this.replacementTexture?.dispose();
    this.placeholderTexture.dispose();
    this.group.traverse(object => {
      if (object instanceof THREE.Mesh) object.geometry.dispose();
    });
    this.panelMaterial.dispose();
  }
}

function drawAssessmentPanel(): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = 1600; canvas.height = 900;
  const ctx = canvas.getContext('2d')!;
  ctx.fillStyle = '#ffffff';
  ctx.beginPath(); ctx.roundRect(20,20,1560,860,18); ctx.fill();
  ctx.fillStyle = '#59b7df'; ctx.fillRect(20,20,1560,8);
  ctx.fillStyle = '#152456';
  ctx.font = '700 28px "GT Haptik", Arial, sans-serif';
  ctx.fillText('PHYSICAL ASSESSMENT',86,112);
  ctx.font = '66px "GT Sectra Fine", Georgia, serif';
  ctx.fillText('Care begins with permission.',86,224);
  ctx.fillStyle = '#4e5259';
  ctx.font = '30px "Museo Sans", Arial, sans-serif';
  ctx.fillText('Listen to the assessment. The clinical picture is being prepared.',88,292);
  const steps = [
    { x:86, title:'Observe', detail:'Notice without deciding' },
    { x:586, title:'Explain', detail:'Share what comes next' },
    { x:1086, title:'Ask permission', detail:'Let autonomy lead' },
  ];
  for (const step of steps) {
    ctx.fillStyle = '#59b7df'; ctx.fillRect(step.x,449,404,3);
    ctx.fillStyle = '#152456'; ctx.font = '42px "GT Sectra Fine", Georgia, serif';
    ctx.fillText(step.title,step.x,528);
    ctx.fillStyle = '#4e5259'; ctx.font = '27px "Museo Sans", Arial, sans-serif';
    ctx.fillText(step.detail,step.x,584);
  }
  ctx.fillStyle = '#dfe1df'; ctx.fillRect(86,752,1428,2);
  ctx.fillStyle = '#4e5259'; ctx.font = '26px "Museo Sans", Arial, sans-serif';
  ctx.fillText('Project TINES | Assessment picture pending',86,818);
  return canvas;
}
